export default "__VITE_ASSET__BGYJ7qRY__"